// Partner Configuration Types
export interface PartnerConfig {
  id: string;
  name: string;
  displayName: string;
  logo: string;
  favicon: string;
  isVrboPartner?: boolean;
  pages?: {
    landing?: {
      partnerIntegration?: {
        logo?: string;
        logoStyle?: string | null;
        partnerLogo?: string;
        integrationText?: string;
        videoUrl?: string | null;
        trustCount?: string;
      };
    };
  };
}

export type { Country } from './country';
export type { State } from './states';

// Cart Model Types
export interface CartModel {
  partnerLeadId?: string;
  productPricing?: ProductPricing[];
  // Add other cart model properties as needed
}

// Product Pricing Types
export interface ProductPricing {
  ProductId: string;
  LineItems: LineItem[];
  // Add other product pricing properties as needed
}

export interface LineItem {
  id: string;
  amount?: number;
  description?: string;
  // Add other line item properties as needed
}

// API Response Types
export interface PartnerLeadData {
  partnerName: string;
  partnerId: string;
  customer: {
    customerId: string;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    billingAddress: {
      addressLine1: string;
      addressLine2?: string;
      city: string;
      state: string;
      Country: string;
      postalCode: string;
    };
  };
  locations: Array<{
    locationId: string;
    nickname: string;
    address: {
      addressLine1: string;
      addressLine2?: string;
      city: string;
      state: string;
      Country: string;
      postalCode: string;
      countryId: number;
      stateProvinceId: number;
    };
  }>;
  receivedDate: string;
  identifier: string;
}

export interface ProductPricingItem {
  productId: number;
  productTypeId?: number;
  name: string;
  subscriptionTypeId: number;
  minPropertyCount?: number;
  maxPropertyCount?: number;
  lineItems: Array<{
    id: number;
    type: number;
    name: string;
    prices: Array<{
      listPrice: number;
    }>;
  }>;
}

// API response for `GET /api/partners/products/pricing?id=<n>`.
// Single product because cartv2 only ever renders one product at a time.
// `null` means no active pricing exists for the requested product.
export type ProductPricingResponse = ProductPricingItem | null;

// API Error Types
export class ApiError extends Error {
  public status?: number;

  constructor(message: string, status?: number) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
  }
}

// Window object extension for gtag
declare global {
  interface Window {
    gtag?: (command: string, action: string, params?: any) => void;
  }
}

export {}; 